import styled from 'styled-components';

export const Wrapper = styled.main`
  padding: 20px 30px 50px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);

  @media (max-width: 767px) {
    .flex-block {
      flex-direction: column;
    }
  }

  .first-stage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .flex-block {
      display: flex;
      gap: 20px;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 0 20px;
      width: 100%;

      .head-line {
        display: flex;
        gap: 10px;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .title {
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          text-align: left;
          color: var(--color-text-muted);
        }

        svg {
          cursor: pointer;

          :hover {
            color: var(--color-accent);
          }
        }
      }

      .left-wrapper,
      .right-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;

        textarea {
          background: var(--color-surface);
          color: var(--color-text);
          border: 1px solid var(--color-border);
          min-height: 40vh;
        }
      }
    }
  }

  .second-stage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .flex-block {
      display: flex;
      gap: 20px;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px 10px;
      width: 100%;

      .left-wrapper,
      .right-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-end;
        align-items: center;
        width: 100%;

        .lines {
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          text-align: left;
          color: var(--color-text-muted);
        }
      }
    }
    button {
      width: 125px;
    }

    .diff {
      min-width: 0;
      overflow-x: auto;
      width: 100%;
      background: var(--color-surface);
      box-shadow: 0 8px 10px var(--color-shadow);
      border: 1px solid var(--color-border);
      border-radius: 10px;
      position: relative;
      flex: 1 0 auto;
      margin: 0 0 20px;

      table {
        background: transparent;
        * {
          font-family: 'General Sans', sans-serif !important;
          font-size: 16px !important;
          line-height: 24px !important;
        }
      }
      table tbody tr:first-child td:first-child {
        border-radius: 10px 0 0 0;
      }
      table tbody tr:first-child td:last-child {
        border-radius: 0 10px 0 0;
      }
      table tbody tr:last-child td:first-child {
        border-radius: 0 0 0 10px;
      }
      table tbody tr:last-child td:last-child {
        border-radius: 0 0 10px 0;
      }
    }
  }
`;
